// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { VulnerabilityPackageDetails } from './vulnerability-package-details';

export interface VulnerabilityPackagesDetailsResult {
  repositoriesVulnerabilityPackagesDetails: VulnerabilityPackageDetails[];
}
